import { FC } from 'react'
import { IconPaths } from '_metronic/helpers'
import styles from '../../Prescricao.module.scss'
import { Icone } from '../comum/Icone'
import { useRotulos } from '../comum/useRotulos'
import { Button } from 'app/components'

export type AcaoPendente = {
  chave: string
  titulo: string
  descricao: string
  rotuloAcao: string
  executar: () => void
  /** Erro de assinatura pesa mais que um lembrete (ex.: saldo baixo). */
  grave?: boolean
}

/** O que ainda falta depois da assinatura: documento com erro, LME/APAC, saldo SNCR baixo. */
export const AcoesPendentes: FC<{ acoes: AcaoPendente[] }> = ({ acoes }) => {
  const { t } = useRotulos()
  if (acoes.length === 0) return null

  return (
    <section className='card card-bordered mb-5' aria-labelledby='resultado-pendentes'>
      <div className='card-body'>
        <h3 id='resultado-pendentes' className='fs-5 fw-bold mb-2'>
          {t('prescricao.resultado.pendentes', { quantidade: acoes.length })}
        </h3>
        <ul className='list-unstyled m-0'>
          {acoes.map((acao, indice) => (
            <li
              key={acao.chave}
              className={`d-flex flex-wrap align-items-center gap-3 py-3 ${
                indice ? 'border-top' : ''
              }`}
            >
              <Icone
                icone={IconPaths.Alert}
                className={`${acao.grave ? styles.estadoErro : styles.pendenciaAviso} fs-3`}
              />
              <span className='flex-grow-1'>
                <strong>{acao.titulo}</strong> · {acao.descricao}
              </span>
              <Button size='btn-sm' className='btn-primary fw-bold' onClick={acao.executar}>
                {acao.rotuloAcao}
              </Button>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
